import { Dropdown } from 'bootstrap.native';

class Dropdowns {
    constructor() {
        this.selectDropdowns();
    }
    selectDropdowns() {
        Array.from(document.querySelectorAll('.js-select-dropdown')).map(dropdown => {
            this.createSelector(dropdown);
        });
    }
    createSelector(dropdown) {
        new Dropdown(dropdown);

        const button = dropdown.querySelector('[data-toggle="dropdown"]');
        const menuButtons = Array.from(dropdown.querySelectorAll('.dropdown-menu__item'));

        menuButtons.map(changeButton => {
            changeButton.addEventListener('click', () => {
                button.innerHTML = changeButton.innerHTML;
            });
        })
    }
}

new Dropdowns();
